import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#053A41",
        d: "M7.356 1.65a.626.626 0 0 0-.961-.8L3.75 4.024 1.106.85a.626.626 0 0 0-.961.8L2.935 5 .146 8.35a.626.626 0 0 0 .96.8L3.75 5.978 6.395 9.15a.626.626 0 0 0 .96-.801L4.566 5z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h7.5v10H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }